export const getTOGGLE_SELECTED_HEADER = panelIdentifier =>
  panelIdentifier + "_TOGGLE_SELECTED_HEADER";

export const getTOGGLE_SELECTED = panelIdentifier =>
  panelIdentifier + "_TOGGLE_SELECTED";
